import {Component, OnInit} from '@angular/core';
import {getUtmList, getUTMhash, getSiteStatusStyle} from "app/lib/lib";
import * as moment from 'moment-timezone';
import {InfoModalComponent} from "../modal/info_modal.component";

@Component({
	template: `
		<info-modal [title]="title" (onOk)="ok()">
			<table class="table">
				<thead>
					<tr>
						<td>{{ 'adminstat.common.Users' | translate }}</td>
						<td>{{ 'adminstat.users.reg_day.created sites' | translate }}</td>
						<td>{{ 'adminstat.users.reg_day.referers' | translate }}</td>
						<td>{{ 'adminstat.users.reg_day.marks' | translate }}</td>
						<td>{{ 'adminstat.users.reg_day.list of sites' | translate }}</td>
					</tr>
				</thead>
				
				<tbody>
					<tr *ngFor="let stat of stats" class="ul-reg-day-item-link">
						<td>{{ stat.userCount }}</td>
						<td>{{ stat.siteCount }}</td>
						
						<td>
							<div [ngbTooltip]="stat.referer" placement="bottom">
								{{ stat.referer | truncate : 25 }}
							</div>
						</td>
						<td>
							<div style="max-width: 300px; display: block;">
								<table class="table">
									<tbody>
										<tr>
											<th>{{ 'adminstat.users.reg_day.utm' | translate }}</th>
											<th>{{ 'adminstat.users.reg_day.value' | translate }}</th>
										</tr>
										
										<tr *ngFor="let key of stat.utmData | keys">
											<td>{{ key }}</td>
											<td>
												{{ (stat.utmData[key] || '').substr(0, 40) }}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</td>
						<td>
							<ngb-accordion #acc="ngbAccordion">
								<ngb-panel title="{{ 'adminstat.users.reg_day.list of sites' | translate }}">
									<ng-template ngbPanelContent>
										<table class="table">
											<thead>
												<tr>
													<th>{{ 'adminstat.common.address' | translate }}</th>
													<th>{{ 'adminstat.users.reg_day.created' | translate }}</th>
													<th>{{ 'adminstat.common.age' | translate }}</th>
												</tr>
											</thead>
											
											<tbody *ngIf="stat.siteList.length > 0">
												<tr *ngFor="let site of stat.siteList">
													<td>
														<site_info [siteUrl]="site.domainUrl"></site_info>
													</td>
													<td>
														{{ moment.utc(site.dateCreate).format('DD-MM-YYYY HH:mm') }}
													</td>
													<td>
														{{ site.age }}
													</td>
												</tr>
											</tbody>
										</table>
									</ng-template>
								</ngb-panel>
							</ngb-accordion>
						</td>
					</tr>
				</tbody>
			</table>
		</info-modal>
  `
})
export class RefDetailComponent extends InfoModalComponent implements OnInit {
	stats: any[];
	type: string;

	public utmList = getUtmList();
	public getUTMhash = getUTMhash;
	public getSiteStatusStyle = getSiteStatusStyle;
	public moment = moment;

	ok() {
		this.close();
	}

	ngOnInit() {
		let me = this;

		this.stats.forEach(function(stat) {
			let utm = getUTMhash(stat.mark);
			
			stat.utmData = me.utmList.reduce(function(obj, utmKey) { if (utm[utmKey]) { obj[utmKey] = utm[utmKey] }; return obj; }, {});
		});
	}
}

